"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectAvatar = exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

var _CroppedImage = _interopRequireDefault(require("../Utils/CroppedImage"));

var _useAvatarForBot3 = _interopRequireDefault(require("../hooks/useAvatarForBot"));

var _useAvatarForUser3 = _interopRequireDefault(require("../hooks/useAvatarForUser"));

var _useStyleSet3 = _interopRequireDefault(require("../hooks/useStyleSet"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var connectAvatar = function connectAvatar() {
  for (var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++) {
    selectors[_key] = arguments[_key];
  }

  return _connectToWebChat.default.apply(void 0, [function (_ref, _ref2) {
    var _ref$styleSet$options = _ref.styleSet.options,
        botAvatarImage = _ref$styleSet$options.botAvatarImage,
        botAvatarInitials = _ref$styleSet$options.botAvatarInitials,
        userAvatarImage = _ref$styleSet$options.userAvatarImage,
        userAvatarInitials = _ref$styleSet$options.userAvatarInitials;
    var fromUser = _ref2.fromUser;
    return {
      avatarImage: fromUser ? userAvatarImage : botAvatarImage,
      avatarInitials: fromUser ? userAvatarInitials : botAvatarInitials
    };
  }].concat(selectors));
}; // TODO: [P2] Consider memoizing "style={ backgroundImage }" in our upstreamers
//       We have 2 different upstreamers <CarouselFilmStrip> and <StackedLayout>


exports.connectAvatar = connectAvatar;

var Avatar = function Avatar(_ref3) {
  var ariaHidden = _ref3['aria-hidden'],
      className = _ref3.className,
      fromUser = _ref3.fromUser;

  var _useAvatarForBot = (0, _useAvatarForBot3.default)(),
      _useAvatarForBot2 = _slicedToArray(_useAvatarForBot, 1),
      botAvatar = _useAvatarForBot2[0];

  var _useAvatarForUser = (0, _useAvatarForUser3.default)(),
      _useAvatarForUser2 = _slicedToArray(_useAvatarForUser, 1),
      userAvatar = _useAvatarForUser2[0];

  var _useStyleSet = (0, _useStyleSet3.default)(),
      _useStyleSet2 = _slicedToArray(_useStyleSet, 1),
      avatarStyleSet = _useStyleSet2[0].avatar;

  var _ref4 = fromUser ? userAvatar : botAvatar,
      image = _ref4.image,
      initials = _ref4.initials;

  return !!(image || initials) && _react.default.createElement("div", {
    "aria-hidden": ariaHidden,
    className: (0, _classnames.default)(avatarStyleSet + '', {
      'from-user': fromUser
    }, className + '')
  }, initials, !!image && _react.default.createElement(_CroppedImage.default, {
    alt: "",
    className: "image",
    height: "100%",
    src: image,
    width: "100%"
  }));
};

Avatar.defaultProps = {
  'aria-hidden': false,
  className: '',
  fromUser: false
};
Avatar.propTypes = {
  'aria-hidden': _propTypes.default.bool,
  className: _propTypes.default.string,
  fromUser: _propTypes.default.bool
};
var _default = Avatar;
exports.default = _default;